import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { useParams, useSearchParams } from 'next/navigation';
import { getCustomerRatingsAndReviewsPageUrl } from '../../helper/getCustomerRatingsAndReviewsPageUrl/getCustomerRatingsAndReviewsPageUrl';
import type { CustomerRatingsAndReviewsPageSearchParams } from '../../types';
import { getSearchParamsValue } from '../../helper/getSearchParamsValue/getSearchParamsValue';

export type GetUrlProps = {
  articleId: string;
  variationId?: string;
  page?: string;
  rating?: string;
};

export const useCustomerRatingsAndReviewPage = () => {
  const params = useParams();
  const searchParams = useSearchParams();
  const { language, localizeUrl } = useI18n();

  const getArticleId = () => {
    if (params === null) {
      return null;
    }
    const productId = params.akl ?? params.slug;
    if (!productId) {
      return null;
    }
    if (Array.isArray(productId)) {
      if (productId.length === 0) {
        return null;
      }
      return productId[0];
    }
    return productId;
  };

  const getUrl = ({ articleId, variationId, page, rating }: GetUrlProps) => {
    let tag;
    if (params?.ftag) {
      tag = Array.isArray(params.ftag) ? params.ftag[0] : params.ftag;
    }

    return localizeUrl(
      getCustomerRatingsAndReviewsPageUrl({
        articleId,
        filterBy: {
          tag,
          rating,
        },
        searchParams,
        variationId,
        page,
      }),
      language,
    );
  };

  const getSearchParamValue = (searchParam: CustomerRatingsAndReviewsPageSearchParams) =>
    getSearchParamsValue(searchParams, searchParam);

  return { getArticleId, getUrl, getSearchParamValue };
};
